{
  "404": {
    "description": "Desculpe, nós não encontramos a página que você estava procurando. Talvez você digitou a URL errada? Confira a URL digitada.",
    "go_to_home": "Voltar ao início",
    "ops_nothing_to_see_here": "Ops, não há nada para para ver aqui",
    "title": "404 Página Não Encontrada"
  },
  "actors": {
    "actor_view": {
      "actor_updated_successfully": "Interveniente atualizado com sucesso!",
      "page_title": "Interveniente",
      "sections": { "company_data": "Dados da Empresa", "notification_groups": "Grupos de Notificação" }
    },
    "actors_list": {
      "actor_deleted": "Interveniente excluído com sucesso!",
      "add_new_actor": "Adicionar Interveniente",
      "page_title": "Intervenientes"
    },
    "new_actor": { "page_title": "Cadastrar Interveniente", "success": "Interveniente adicionado com sucesso" }
  },
  "agents": {
    "all_agents": "Todos Agentes",
    "btn_create": "Criar Agente",
    "create_success": "Agente criado com sucesso",
    "executions": {
      "cards": { "total": "Total de Execuções", "errors": "Erros", "today": "hoje" },
      "new": "Novo Agente",
      "page_title": "Execuções de Agentes",
      "status": { "failed": "Erro", "all": "Todos" },
      "table": { "duration": "Duração", "entity_type": "Tipo de Entidade", "scheduled": "Agendada" },
      "tabs": { "production": "Produção", "test_runs": "Execução de Testes" },
      "test_run": "Testar Execução",
      "detail": {
        "action": "Ação",
        "callback_curl": "Ou dispare o callback você mesmo — seu serviço deve fazer um POST com algo equivalente a isso.",
        "callback_url": "URL do Callback (resultado do POST aqui)",
        "dispatch": { "waiting_callback": "Aguardando callback" },
        "entity_data": "Dados da entidade",
        "insights_successful": "{{count}} insights inseridos/atualizados",
        "orders_successful": "{{count}} pedidos inseridos/atualizados",
        "output": "Saída",
        "processes_successful": "{{count}} processos inseridos/atualizados",
        "processes_tracked_successful": "{{count}} processos atualizados",
        "processing": "Processando",
        "started_at": "Iniciado em",
        "step_not_started": "Esta etapa ainda não foi executada.",
        "steps": "Passos",
        "trigger": "Gatilho",
        "triggered_at": "Disparado em",
        "webhook_response": "Resposta do webhook",
        "manual_curl": {
          "label": "cURL Manual — execute isso na sua máquina",
          "description": "A execução aguarda um callback. Cole o cURL abaixo no terminal — ele já vem com a URL do processador configurada no agente. Você pode alterá-la para chamar outro endpoint, inclusive local. Seu serviço roda e faz um POST para a URL de callback abaixo — não precisa de túnel."
        },
        "status": {
          "failed": "erro",
          "pending": "pendente",
          "running": "executando",
          "skipped": "ignorada",
          "success": "concluído"
        }
      },
      "dev_mode_modal": {
        "dispatch_hint": "A Flowls envia um POST com o input para a URL configurada do agente.",
        "execute_actions_hint": "Ações executam como em produção — escritas no banco de dados acontecerão.",
        "execute_actions": "Executar ações",
        "invalid_json": "JSON inválido. Corrija o JSON para executar o teste.",
        "manual_curl_hint": "Não é feito um POST de saída. Flowls gera um cURL que você executa localmente — não precisa de túnel.",
        "run_test": "Executar teste",
        "select_lpco_input": "Selecione uma Lpco",
        "select_order_input": "Selecione um Pedido",
        "select_process_input": "Selecione um Processo",
        "skip_actions_hint": "Valide a forma do callback mas NÃO escreva no banco de dados.",
        "skip_actions": "Ignorar ações (padrão)",
        "title": "Compor execução de teste",
        "input_label": "Input"
      }
    },
    "form": {
      "step_name": {
        "subtitle": "Dê um nome claro a este agente para facilitar a identificação.",
        "title": "Nomeie seu agente"
      },
      "step_trigger": {
        "subtitle": "Defina o que inicia este agente.",
        "title": "Escolha um Gatilho",
        "descriptions": {
          "event_trigger": "Disparar quando um evento específico ocorrer em um registro",
          "received_mail": "Disparar quando um email chegar na caixa de entrada",
          "received_teams_message": "Disparar a partir de um canal ou DM no Teams",
          "recurring_schedule": "Executar em intervalo fixo (diário, semanal, etc.)",
          "webhook": "Receber um POST de um sistema externo"
        },
        "event_trigger_form": { "entity": "Entidade", "entity_subtitle": "Selecione o tipo de registro monitorado." },
        "recurring_schedule_form": {
          "frequency_periods": { "DAYS": "dias", "HOURS": "horas", "WEEKS": "semanas" },
          "frequency": "Frequência",
          "recurring_schedule": "Executar a cada"
        },
        "webhook": { "info": "A URL e API Key do webhook de entrada será gerada após a criação do agente." }
      },
      "step_configure_input": {
        "subtitle": "Defina de onde vêm os dados para este agente.",
        "title": "Configure o Input",
        "descriptions": {
          "external_api": "Chamar uma API REST para buscar dados",
          "google_drive": "Ler dados de uma planilha do Google Sheets",
          "no_input": "Executar o agente sem nenhum input",
          "operations": "Selecione operações, entidade e filtros",
          "sharepoint": "Buscar dados de uma lista do SharePoint"
        },
        "operations_form": {
          "filters": "Processar apenas registros que atendem a estas condições.",
          "operation_description": "Selecione quais operações este agendamento executa."
        }
      },
      "step_processor": {
        "configure_title": "Configurar: {{ processor }}",
        "subtitle": "Selecione a etapa lógica que analisa ou transforma a entrada.",
        "title": "Escolha um Processador",
        "form": {
          "custom_webhook": {
            "auth_type": "Autenticação",
            "credential": "Credencial de autenticação",
            "disclaimer": "Este processador envia o payload do agente para o seu endpoint, que pode transformar os dados antes de as ações selecionadas serem executadas.",
            "expected_keys": "Chaves esperadas na resposta: `orders`, `processes`.",
            "headers": { "key": "Chave", "value": "Valor" }
          }
        }
      },
      "step_actions": {
        "default": "Padrão",
        "disclaimer": "As ações serão executadas na sequência automaticamente.",
        "subtitle": "Uma ação padrão é incluída automaticamente. Você pode adicionar mais opcionalmente.",
        "title": "Ações",
        "descriptions": {
          "post_in_teams": "Publicar uma mensagem em um canal do Microsoft Teams",
          "send_email": "Enviar um email para um destinatário ou função responsável",
          "set_insights": "Salvar os achados de inconsistências",
          "update_tracking": "Atualizar os dados de tracking dos processos a partir dos dados recebidos",
          "upload_document": "Criar um documento para uma entidade específica",
          "upsert_orders": "Criar ou atualizar pedidos a partir dos dados recebidos",
          "upsert_processes": "Criar ou atualizar processos a partir dos dados recebidos",
          "upsert_products": "Criar ou atualizar produtos a partir dos dados recebidos"
        },
        "infos": {
          "update_tracking": "Esta ação consome <b>processes</b>.",
          "upsert_orders": "Esta ação consome <b>orders</b>.",
          "upsert_processes": "Esta ação consome <b>processes</b>.",
          "upsert_products": "Esta ação consome <b>products</b>."
        }
      }
    },
    "list": { "page_title": "Agentes Configurados", "new": "Novo Agente" }
  },
  "attendance_phase": { "subsidiary": { "title": "Transportador" } },
  "audit_checklist": {
    "approve_audit": "Aprovar Auditoria",
    "do_you_want_to_audit_order": "Deseja aprovar a auditoria?",
    "title": "Checklist"
  },
  "automations": {
    "creation": {
      "fields_for_categories": {
        "1": { "args": { "1": { "title": "Quando passar" } } },
        "2": { "args": { "1": { "title": "Quando passar" }, "2": { "title": "Sem confirmação de" } } },
        "3": { "args": { "1": { "title": "Quando faltar" } } },
        "4": { "args": { "1": { "title": "Quando faltar" }, "2": { "title": "Sem confirmação de" } } },
        "5": { "args": { "1": { "title": "Quando chegar" } } },
        "6": { "args": { "1": { "title": "Quando chegar" }, "2": { "title": "Sem confirmação de" } } },
        "7": { "args": { "1": { "title": "Quando" }, "2": { "title": "for posterior a" }, "3": { "title": "por" } } }
      },
      "form": {
        "date_field": { "in": "de" },
        "field": "Campo",
        "filters": "Para as condições:",
        "quantity": "Qtde.",
        "success": "Automação criada com sucesso!",
        "webhook": "Informar URL"
      },
      "templates": { "label": "Templates de data" },
      "title": "Criar automação"
    },
    "delete": { "success": "Automação excluída com sucesso!", "title": "Excluir {{title}}?" },
    "list": {
      "descriptions": {
        "AFTER_DATE": "Quando passar <b>{{amount}}</b> <b>{{type}}</b> de <b>{{date}}</b>",
        "AFTER_DATE_WITH_FIELD": "Quando passar <b>{{amount}}</b> <b>{{type}}</b> de <b>{{date}}</b> sem confirmação de <b>{{confirmation}}</b>",
        "BEFORE_DATE": "Quando faltar <b>{{amount}}</b> <b>{{type}}</b> para <b>{{date}}</b>",
        "BEFORE_DATE_WITH_FIELD": "Quando faltar <b>{{amount}}</b> <b>{{type}}</b> para <b>{{date}}</b> sem confirmação de <b>{{confirmation}}</b>",
        "ON_DATE": "Quando chegar <b>{{date}}</b>",
        "ON_DATE_WITH_FIELD": "Quando chegar <b>{{date}}</b> sem confirmação de <b>{{confirmation}}</b>",
        "ON_DATE_GREATER_THAN": "Quando <b>{{date}}</b> for posterior a <b>{{dateTarget}}</b> por <b>{{amount}}</b> <b>{{type}}</b>"
      },
      "periods": {
        "DAYS": "dias",
        "DAYS_one": "dia",
        "HOURS": "horas",
        "HOURS_one": "hora",
        "MINUTES": "minutos",
        "MINUTES_one": "minuto",
        "MONTHS": "meses",
        "MONTHS_one": "mês"
      },
      "title_one": "{{count}} automação em <b>{{operationName}}</b>",
      "title_other": "{{count}} automações em <b>{{operationName}}</b>"
    },
    "periods": { "DAYS": "Dias", "HOURS": "Horas", "MINUTES": "Minutos", "MONTHS": "Meses" },
    "status": { "off": "OFF", "on": "ON" },
    "templates": {
      "AFTER_DATE": "Quando passar <b>um período</b> de <b>uma data</b>",
      "AFTER_DATE_WITH_FIELD": "Quando passar <b>um período</b> de <b>uma data</b> sem <b>confirmação de um campo</b>",
      "BEFORE_DATE": "Quando faltar <b>um período</b> para <b>uma data</b>",
      "BEFORE_DATE_WITH_FIELD": "Quando faltar <b>um período</b> para <b>uma data</b> sem <b>confirmação de um campo</b>",
      "ON_DATE": "Quando chegar <b>uma data</b>",
      "ON_DATE_WITH_FIELD": "Quando chegar <b>uma data</b> sem <b>confirmação de um campo</b>",
      "ON_DATE_GREATER_THAN": "Quando <b>uma data</b> for posterior a <b>outra data</b> por <b>um período</b>"
    }
  },
  "booking_quotations": {
    "detail": {
      "back": "Voltar para cotações",
      "canceled_at": "Cancelada em",
      "closed_at": "Encerrada em",
      "closes_at": "Encerra em",
      "draft_empty": "A cotação ainda não foi enviada. O envio é feito pelo processo.",
      "history": "Histórico",
      "history_empty": "Nenhum evento registrado.",
      "history_events": {
        "CLOSED": "Cotação encerrada automaticamente",
        "FREIGHT_FORWARDER_DECLINED": "{{agent}} declinou",
        "PROPOSAL_SUBMITTED": "{{agent}} enviou proposta",
        "PROPOSAL_WITHDRAWN": "{{agent}} cancelou a proposta",
        "SENT_one": "Cotação enviada a {{count}} agente",
        "SENT_other": "Cotação enviada a {{count}} agentes",
        "declined_one": "{{count}} declinou",
        "declined_other": "{{count}} declinaram",
        "responded_one": "{{count}} de {{total}} respondeu",
        "responded_other": "{{count}} de {{total}} responderam"
      },
      "not_found": "Cotação não encontrada.",
      "opened_at": "Aberta em",
      "order": "Pedido {{code}}",
      "received_proposals": "Propostas recebidas",
      "route": "Carregamento → Descarregamento",
      "summary": "Resumo",
      "total_freight": "Frete total",
      "transit_days_one": "{{count}} dia de trânsito",
      "transit_days_other": "{{count}} dias de trânsito"
    },
    "list": {
      "columns": {
        "identification": "Identificação",
        "operation_route": "Operação / Rota",
        "period": "Período",
        "proposals": "Propostas",
        "status": "Situação"
      },
      "order": "pedido {{code}}",
      "page_title": "Cotações",
      "period": { "closed": "encerrada", "no_return": "sem retorno", "to_close": "p/ encerrar" },
      "proposals": {
        "none": "Nenhuma proposta recebida",
        "responded": "{{responded}} de {{invited}} respondidas",
        "sealed": "valores em sigilo"
      },
      "search_placeholder": "Buscar cotação…",
      "sort": { "closes_at": "Encerramento", "inserted_at": "Registro", "published_at": "Envio" },
      "status": { "today": "hoje {{time}}" },
      "title": "Cotações",
      "view_action": "Visualizar cotação"
    }
  },
  "buttons": {
    "add": "Adicionar",
    "active": "Ativar",
    "archive": "Arquivar",
    "back": "Voltar",
    "cancel": "Cancelar",
    "close": "Fechar",
    "clear_all": "Limpar todos",
    "confirm": "Confirmar",
    "delete": "Deletar",
    "download": "Baixar",
    "edit": "Editar",
    "filters": "Filtros",
    "process_filters": "Filtros",
    "lead_time_filters": "Lead Time",
    "go_to_home": "Voltar ao início",
    "hide": "Esconder",
    "hide_all": "Esconder todos",
    "inactive": "Inativar",
    "keep_editing": "Continuar Editando",
    "not_save": "Não salvar",
    "register": "Cadastrar",
    "remove": "Remover",
    "save": "Salvar",
    "save_changes": "Salvar alterações",
    "show": "Exibir",
    "show_all": "Mostrar todos",
    "undo_cancel": "Desfazer Cancelamento",
    "undo_delete": "Desfazer deleção",
    "view": "Visualizar",
    "yes_delete": "Sim, excluir"
  },
  "common": {
    "cellphone": "Telefone",
    "copied": "Copiado",
    "copy": "Copiar",
    "hours": "Horas",
    "plate": "Placa",
    "type": "Tipo"
  },
  "datagrid": {
    "actionsCellMore": "mais",
    "checkboxSelectionHeaderName": "Selecionar checkbox",
    "columnHeaderFiltersLabel": "Mostrar filtros",
    "columnHeaderSortIconLabel": "Ordenar",
    "columnMenuFilter": "Filtros",
    "columnMenuHideColumn": "Esconder",
    "columnMenuLabel": "Menu",
    "columnMenuManageColumns": "Gerenciar Colunas",
    "columnMenuShowColumns": "Mostrar colunas",
    "columnMenuSortAsc": "Ordenar ascendente",
    "columnMenuSortDesc": "Ordenar descendente",
    "columnMenuUnsort": "Não ordenar",
    "sortByTitle": "Ordenar por",
    "sortDirectionTitle": "Sentido",
    "sortDirectionDesc": "Decrescente",
    "sortDirectionAsc": "Crescente",
    "dateFilterTitle": "Filtrar por data",
    "dateFilterStart": "Início",
    "dateFilterEnd": "Fim",
    "dateFilterClear": "Limpar período",
    "columnsManagementSearchTitle": "Encontrar coluna",
    "columnsManagementShowHideAllText": "Mostrar/Ocultar tudo",
    "columnsManagementNoColumns": "Sem colunas",
    "columnsManagementReset": "Resetar",
    "filterOperatorAfter": "após",
    "filterOperatorBefore": "antes de",
    "filterOperatorContains": "contém",
    "filterOperatorEndsWith": "termina com",
    "filterOperatorEquals": "igual",
    "filterOperatorIs": "é",
    "filterOperatorIsAnyOf": "é qualquer um dos",
    "filterOperatorIsEmpty": "é vazio",
    "filterOperatorIsNotEmpty": "não vazio",
    "filterOperatorNot": "não é",
    "filterOperatorNotContains": "não contém",
    "filterOperatorNotEquals": "diferente",
    "filterOperatorIsNoneOf": "não é nenhum dos",
    "filterOperatorOnOrAfter": "em ou após",
    "filterOperatorOnOrBefore": "em ou antes de",
    "filterOperatorStartsWith": "começa com",
    "filterPanelAddFilter": "Adicionar filtro",
    "filterPanelColumns": "Colunas",
    "filterPanelDeleteIconLabel": "Remover",
    "filterPanelInputLabel": "Valor",
    "filterPanelInputPlaceholder": "Filtrar valor",
    "filterPanelOperator": "Operadores",
    "filterPanelOperatorAnd": "E",
    "filterPanelOperatorOr": "Ou",
    "filterPanelRemoveAll": "Limpar Filtros",
    "filterValueAny": "Qualquer",
    "filterValueFalse": "Não",
    "filterValueTrue": "Sim",
    "footerRowSelectedMore": "{{count}} linhas selecionadas",
    "footerRowSelectedOne": "1 linha selecionada",
    "footerTotalRows": "Total",
    "footerTotalVisibleRows": "{{visibleCount}} de {{totalCount}}",
    "labelDisplayedRows": "{{from}} - {{to}} de {{count}}",
    "labelDisplayedRowsUnknown": "{{from}} - {{to}}",
    "labelRowsPerPage": "Linhas por página",
    "noResultsOverlayLabel": "Sem resultados encontrados",
    "noRowsLabel": "Sem resultados",
    "pinToLeft": "Fixar à esquerda",
    "pinToRight": "Fixar à direita",
    "toolbarColumns": "Colunas",
    "toolbarColumnsLabel": "Selecionar colunas",
    "toolbarDensity": "Densidade",
    "toolbarDensityComfortable": "Confortável",
    "toolbarDensityCompact": "Compacto",
    "toolbarDensityStandard": "Padrão",
    "toolbarExport": "Exportar",
    "toolbarExportCSV": "Baixar CSV",
    "toolbarFilters": "Filtros",
    "toolbarFiltersLabel": "Ver filtros",
    "toolbarFiltersTooltipActiveMore": "{{count}} filtros ativos",
    "toolbarFiltersTooltipActiveOne": "1 filtro ativo",
    "toolbarFiltersTooltipHide": "Esconder filtros",
    "unpin": "Desafixar"
  },
  "datepickers": {
    "range_shortcuts": {
      "this_week": "Esta Semana",
      "last_week": "Última Semana",
      "last_7_days": "Últimos 7 Dias",
      "last_30_days": "Últimos 30 Dias",
      "current_month": "Mês Atual",
      "last_month": "Mês Passado",
      "reset": "Resetar"
    }
  },
  "drivers": {
    "drivers_list": {
      "add_new_driver": "Adicionar motorista",
      "driver_deleted": "Motorista excluído com sucesso!",
      "page_title": "Motoristas",
      "title": "Motoristas"
    },
    "drivers_new": {
      "page_title": "Cadastrar Motorista",
      "success": "Motorista adicionado com sucesso",
      "title": "Cadastrar Motorista"
    },
    "edit_driver": {
      "page_title": "Editar Motorista",
      "success": "Motorista atualizado com sucesso",
      "title": "Editar Motorista"
    }
  },
  "entities_report": {
    "actor": "Intervenientes",
    "driver": "Motoristas",
    "mercante": "Mercante",
    "product": "Produtos",
    "route": "Rotas",
    "trailer": "Reboques",
    "vehicle": "Veículos"
  },
  "errors": { "something_went_wrong": "Algo deu errado!" },
  "external_invite": {
    "attachments": {
      "count_one": "{{count}} arquivo",
      "count_other": "{{count}} arquivos",
      "dropzone_title_one": "Arraste o arquivo ou clique para enviar",
      "dropzone_title_other": "Arraste arquivos ou clique para anexar",
      "file_invalid_type": "{{name}}: tipo de arquivo não aceito",
      "file_too_large": "{{name}}: excede 10 MB",
      "optional": "— opcional",
      "select_files_one": "Selecionar arquivo",
      "select_files_other": "Selecionar arquivos"
    },
    "booking_data": {
      "booking_number": "Número do booking",
      "closed_description": "O ATD foi registrado e esta página está somente leitura.",
      "confirm_description": "Confira os dados antes de enviar. O envio atualiza o processo e substitui os valores atuais.",
      "copy_to": "Um resumo será enviado para {{email}}.",
      "document": "Documento do booking (PDF)",
      "document_caption": "Somente PDF, até 10 MB",
      "editable_until_atd": "Você pode corrigir e reenviar até o ATD.",
      "eta_before_etd": "O ETA não pode ser anterior ao ETD.",
      "form_hint": "Informe o número, o documento e o roteiro confirmados com o armador.",
      "load_error": "Não foi possível carregar os dados do embarque. Recarregue a página.",
      "review": "Revisar",
      "send": "Enviar booking",
      "sent": "Booking enviado.",
      "winner_proposal": "proposta vencedora {{number}}. Preencha os dados do booking abaixo."
    },
    "booking_quotation": {
      "all_proposals": "Todas as propostas enviadas",
      "closed_description": "Encerrada em {{date}}. Estas são as propostas enviadas.",
      "completed_description": "O agente vencedor foi selecionado. Agradecemos a participação.",
      "confirm_edit_description": "Confira as alterações antes de salvar. A proposta pode ser editada até o encerramento.",
      "confirm_send_description": "Confira o resumo antes de enviar. A proposta pode ser editada até o encerramento.",
      "copy_to": "Uma cópia será enviada para {{email}}.",
      "days_one": "{{count}} dia",
      "days_other": "{{count}} dias",
      "decline": "Não vou participar",
      "decline_confirm": "Declinar participação",
      "decline_confirm_description": "Você deixará de participar desta cotação e não poderá enviar propostas. Se quiser, conte o motivo ao embarcador.",
      "decline_confirm_title": "Não vou participar",
      "decline_reason_hint": "As observações ficam visíveis apenas para o embarcador.",
      "decline_reason_label": "Motivo (opcional)",
      "declined_description": "Você informou que não vai participar desta cotação. Agradecemos o retorno.",
      "declined_title": "Participação declinada",
      "dropzone_caption": "PDF, XLSX, DOCX ou imagem · até 10 MB cada · vários arquivos",
      "edit": "Editar proposta {{sequence}}",
      "editable_until_close": "Edição disponível até o encerramento.",
      "editing": "Em edição",
      "empty_proposals": "Você não enviou propostas para esta cotação.",
      "international": "Internacional",
      "international_transport": "Transporte internacional",
      "load_error": "Não foi possível carregar a cotação. Recarregue a página.",
      "new_proposal": "Nova proposta",
      "proposals_sent_one": "{{count}} proposta enviada",
      "proposals_sent_other": "{{count}} propostas enviadas",
      "review": "Revisar",
      "send": "Enviar proposta",
      "sent": "Proposta enviada.",
      "sent_at": "Valores em Dólar americano (USD). Enviada em {{date}} — editável até o encerramento.",
      "subtotal": "subtotal",
      "table_summary": "Resumo",
      "total_hint": "soma dos três blocos, calculada automaticamente",
      "updated": "Proposta atualizada.",
      "values_hint": "Valores em Dólar americano (USD). Edição disponível até o encerramento.",
      "withdraw": "Retirar proposta {{sequence}}",
      "withdraw_confirm_description": "A proposta deixa de valer para esta cotação e não pode ser reenviada.",
      "withdraw_confirm_title": "Retirar a proposta {{sequence}}?",
      "withdrawn": "Proposta retirada.",
      "your_proposal": "Sua proposta"
    },
    "canceled": {
      "description": "Esta cotação foi cancelada pelo embarcador em <strong style=\"white-space:nowrap\">{{date}}</strong>. Não é possível enviar ou editar a proposta.",
      "description_BOOKING_DATA": "Esta solicitação de booking foi cancelada pelo embarcador em <strong style=\"white-space:nowrap\">{{date}}</strong>. Não é possível enviar os dados do booking.",
      "tip": "As propostas enviadas foram arquivadas. Em caso de dúvida, contate o responsável pela operação.",
      "tip_BOOKING_DATA": "Em caso de dúvida, contate o responsável pela operação.",
      "title": "Convite cancelado",
      "title_BOOKING_DATA": "Solicitação de booking cancelada",
      "title_BOOKING_QUOTATION": "Cotação cancelada"
    },
    "expired": {
      "description": "O período desta cotação foi encerrado em <strong style=\"white-space:nowrap\">{{date}}</strong>. Não é possível enviar ou editar a proposta.",
      "tip": "Para participar de uma nova rodada, solicite um link atualizado ao contato responsável pela operação.",
      "title": "Link expirado"
    },
    "not_found": {
      "description": "Não encontramos um convite para este link. Verifique se o endereço foi copiado corretamente.",
      "title": "Link inválido"
    },
    "otp_form": {
      "code_expiry_hint": "O código expira em 10 minutos",
      "description": "Enviamos um código de 6 dígitos para {{email}}. Digite o código para abrir o formulário de proposta.",
      "resend_cooldown": "Reenviar código em {{time}}",
      "resend_link": "Não recebeu? Reenviar código",
      "security_notice": "Acesso por link único, sem cadastro na Flowls. O link e o código valem apenas para este convite.",
      "submit": "Acessar formulário",
      "title": "Confirme seu acesso",
      "try_again": "Tentar novamente"
    }
  },
  "extra_fields": { "boolean": { "empty": "Vazio", "false": "Não", "true": "Sim" } },
  "file_uploads": {
    "accepted_extensions": "Extensões aceitas: {{ extensions }}",
    "saved_files": "Arquivos salvos",
    "upload_file": "Enviar arquivo"
  },
  "first_letters": { "days": "d", "hours": "h" },
  "flowls_ai": {
    "beta_warning": "🚧 Esta funcionalidade está em fase Beta. Por favor, verifique as informações fornecidas.",
    "error_message": "Houve um problema para enviar sua mensagem. Tente novamente mais tarde.",
    "greetings": "Olá! Eu sou o Flowlzito, a Inteligência Artificial da Flowls. Como posso ajudar?",
    "input_placeholder": "Faça uma pergunta",
    "loading": "Estou pensando",
    "new_conversation": "Iniciar uma nova conversa"
  },
  "fields": { "duimp": { "advance_delivery": "Entrega Antecipada" } },
  "foreign_trade": {
    "documents_widgets": {
      "automatic_link_tooltip": "Vinculado automaticamente",
      "label": {
        "ANVISA": "ANVISA",
        "BLUE": "Canal Azul",
        "GRAY": "Canal Cinza",
        "GREEN": "Canal Verde",
        "INMETRO": "INMETRO",
        "MAPA": "MAPA",
        "ORANGE": "Canal Laranja",
        "RED": "Canal Vermelho",
        "YELLOW": "Canal Amarelo"
      }
    },
    "invoice_widgets": {
      "brazilian": {
        "drawer": {
          "access_key": "Chave de acesso",
          "sections": { "dates": { "emitted_at": "Data de emissão", "title": "Datas" } },
          "title": "Nota fiscal nº",
          "types": { "0": "Entrada", "1": "Saída" }
        }
      },
      "empty_widget": "Este processo ainda não tem invoices cadastradas.",
      "products": { "import_products": "Importar Produtos" }
    },
    "palletization": {
      "title": "Paletização",
      "read_only": "Somente leitura",
      "add_pallets": "Adicionar Pallets",
      "empty": "Nenhum tamanho informado",
      "size": "Tamanho do pallet",
      "quantity": "Qtd.",
      "height_cm": "Altura (cm)",
      "not_informed": "Não informar o tamanho",
      "iso_group": "Padrão ISO 6780",
      "custom_option": "Customizado…",
      "custom": "Customizado",
      "total": "Total de pallets",
      "empty_description": "Informe quantos pallets serão embarcados de cada tamanho.",
      "size_placeholder": "Selecione o tamanho…",
      "not_informed_group": "Sem detalhamento",
      "not_informed_option_hint": "só a quantidade total",
      "not_informed_hint": "Só a quantidade total — sem detalhar por tamanho.",
      "custom_option_hint": "informar C × L",
      "custom_title": "Tamanho customizado",
      "length": "Comprimento",
      "width": "Largura",
      "errors": {
        "row_invalid": "Informe o tamanho e uma quantidade maior que zero, ou remova a linha.",
        "height_invalid": "A altura deve ser maior que zero.",
        "dimension_invalid": "Deve ser maior que zero"
      }
    },
    "road_transport": {
      "empty_road_transport": "Este processo ainda não tem transportes rodoviários cadastrados.",
      "fields": { "DTA": "DTA", "no_DTA": "Não DTA" },
      "transport": {
        "container": "Container {{number}}",
        "empty_transport_list": "Este processo ainda não tem transportes cadastrados.",
        "route_required_to_add_trips": "Selecione uma rota para habilitar as viagens."
      }
    },
    "shared_widgets": {
      "alert_status": {
        "invalid": "Chave de rastreio inválida.",
        "not_found": "Dados não encontrados. Confira o número inserido.",
        "pending": "Aguardando Dados"
      },
      "authorization_status_alert": {
        "forbidden": "O usuário não tem permissão para acessar o recurso solicitado, verifique as credenciais",
        "not_authorized": "Credenciais inválidas. Certifique-se de ter fornecido as credenciais de segurança corretas"
      },
      "ce_mercante_alert": "Devido a limitação da API de origem, não é possível identificar eventos ocorridos anteriormente ao início do rastreamento.",
      "cleared_duimp_alert": "Devido a limitações da API do Siscomex, ainda não é possível obter a Data de Desembaraço quando a DUIMP é inserida já desembaraçada.",
      "insertedAtLabel": "Inserido em {{date}}",
      "updatedAtLabel": "Atualizado em {{date}}"
    },
    "tracking_widgets": {
      "air": {
        "drawer": {
          "account": "Conta",
          "arrival_at": "Data de Chegada efetiva",
          "arrival_datetime": "Data/hora da chegada",
          "arrival_unit_rfb": "Unidade da RFB de chegada",
          "basic_info": "Informação básicas",
          "cargo_items": "Itens da Carga",
          "collect": "Collect",
          "consignee": "Consignatário",
          "currency": "Moeda de Origem",
          "customs_of_arrival": "Recinto Aduaneiro de Chegada",
          "customs_of_departure": "Recinto Aduaneiro de Partida",
          "customs_of_destination": "Recinto Aduaneiro de Destino",
          "departure_at": "Data de Partida efetiva",
          "departure_datetime": "Data/hora da partida",
          "departure_unit_rfb": "Unidade da RFB da Partida",
          "domestic_departure": "Partida nacional",
          "estimated_arrival_at": "Data de Chegada prevista",
          "estimated_departure_at": "Data de Partida prevista",
          "file_cargo_responsible": "Responsável pelo arquivo do conhecimento de carga",
          "flight_code": "Código do voo",
          "inlet_term": "Termo de Entrada",
          "international_departure": "Partida no exterior",
          "item_description": "Descrição da Mercadoria",
          "item_freight_price": "Frete por item de carga (somatório)",
          "item_gross_weight": "Peso Bruto (kg)",
          "item_quantity_of_volumes": "Quantidade de Volumes",
          "land_arrivals": "Chegadas de viagens terrestres",
          "mawb": "MAWB",
          "prepaid": "Prepaid",
          "receive_cargo": "Presença de Carga",
          "ruc_number": "Número do RUC",
          "shipper": "Embarcador",
          "term": "Termo",
          "title": "Carga Aérea",
          "trips": "Viagens",
          "uf": "UF"
        }
      },
      "ce_mercante": {
        "drawer": {
          "cargo_category": "Categoria Carga",
          "consignee": "Consignatário",
          "cubage": "Cubagem (m³)",
          "freight": "Frete",
          "freight_component_currency": "Moeda",
          "freight_component_payment_type": "Recolhimento",
          "freight_component_type": "Tipo",
          "freight_component_value": "Valor",
          "freight_components": "Componentes do Frete",
          "general_data": "Dados Gerais do Conhecimento",
          "modality": "Modalidade",
          "type": "Tipo Conhecimento"
        }
      },
      "maritime": {
        "containers": {
          "hide_unlinked": "Não exibir Containers Desvinculados",
          "link_container": "Vincular Container ao Processo",
          "show_unlinked": "Exibir Containers Desvinculados",
          "unlink_container": "Desvincular Container do Processo"
        },
        "labels": { "automatic": "Tracking automático" },
        "international_transport_legs": { "title": "Legs" }
      }
    }
  },
  "form_sections": {
    "audit": { "approve_audit": { "audit_approved": "Auditoria aprovada", "title": "Aprovar Auditoria" } },
    "complete_registration": {
      "complete_btn": "Completar Cadastro",
      "country_input": "Selecione seu país",
      "description": "Esse é seu primeiro acesso à plataforma, precisamos confirmar alguns dados para completar seu cadastro.",
      "success_completion": "👏🏼 🎉 Tudo certo, {{ name }}! Agora você pode começar a usar a Flowls!",
      "terms_and_conditions": "Estou de acordo com os Termos de Uso e Política de Privacidade",
      "title": "Olá, bem-vinda(o) a Flowls!"
    },
    "document_uploads": { "empty_document_list": "Ainda não há documentos enviados" },
    "export_dates_form": { "title": "Datas do Pedido" },
    "supplier_form": { "title": "Datas do Pedido" },
    "widgets": {
      "drawer": {
        "content": {
          "advance_delivery": "Entrega Antecipada",
          "basic": "Informações básicas",
          "complement": "Informações complementares",
          "boarding": "Embarque",
          "cargo": "Carga",
          "cargo_subfields": {
            "area": "Recinto",
            "arrival_date_time": "Data/hora Chegada",
            "cargo_identification": "Identificação da Carga",
            "commercial_invoice": "Fatura Comercial Vinculada",
            "customs_area": "Recinto Aduaneiro",
            "dispatch_units": "Unidades de Despacho",
            "final_destination_unit_of_the_bill_of_lading": "Unidade de Destino Final do Conhecimento da Carga",
            "gross_weight": "Peso Bruto (kg)",
            "inlet_outlet_unit": "Unidade de entrada/descarga",
            "net_weight": "Peso Líquido (kg)",
            "origin_country": "País de Origem"
          },
          "clearance": "Desembaraço",
          "consents": "Anuências",
          "consents_subfields": {
            "boarding_expiry_date": "Data Valid. Embarque",
            "consenting_body": "Orgão Anuente",
            "consenting_situation": "Situação Anuência",
            "dispatch_expiry_date": "Data Valid. Despacho",
            "license_text": "Texto Anuente"
          },
          "admin_controls_subfields": {
            "admin_control_body": "Órgão",
            "admin_control_situation": "Situação da Conferência dos Anuentes",
            "risk_analyses_result": "Resultado da Análise de Risco",
            "situation_licensing": "Situação do Licenciamento"
          },
          "customs_subfields": {
            "custom_body": "Órgão",
            "custom_situation": "Situação da Conferência Aduaneira",
            "risk_analyses_result": "Resultado da Análise de Risco"
          },
          "dates": "Datas",
          "delivered": "Entrega",
          "due_events_table": {
            "action": "Evento",
            "date": "Data/Hora",
            "extra_info": "Informações adicionais",
            "responsible": "Responsável"
          },
          "exporter_subfields": { "ruc": "RUC" },
          "general": "Dados Gerais",
          "general_subfields": {
            "delivery_status": "Situação Entrega",
            "protocol": "Protocolo",
            "retification": "Retificação",
            "total_additions": "Total de Adições"
          },
          "importer": "Importador",
          "importer_subfields": {
            "address": "Endereço",
            "identifier": "CNPJ",
            "name": "Nome",
            "rfb": "Unid. RFB Despacho"
          },
          "national_registration": "CNPJ",
          "packages": "Embalagens",
          "packages_subfields": {
            "cargo_item": "Item Carga",
            "danger_class": "Classe de Perigo",
            "dangerous_goods": "Mercadoria Perigosa",
            "gross_weight": "Peso Bruto (kg)",
            "package_type": "Tipo de Embalagem",
            "quantity": "Quantidade",
            "type": "Tipo",
            "use_wooden_packaging": "Utiliza Embalagem Madeira",
            "wood_packaging_feature": "Característica Embalagem Madeira"
          },
          "payments": "Pagamentos",
          "payments_subfields": {
            "fee_value": "Valor Multa",
            "payment_date": "Data Pagamento",
            "total_value": "Valor Total",
            "type": "Tipo de Pagamento"
          },
          "register": "Registro",
          "situation": "Situação",
          "situation_subfields": {
            "admin_control": "Controle Administrativo",
            "cargo_control": "Controle de Carga",
            "customs_control": "Controle Aduaneiro"
          }
        },
        "forms": {
          "comment_helper_text": "Este comentário será salvo quando você salvar as alterações feitas a esse processo."
        }
      }
    }
  },
  "global_tracking": {
    "no_content": "Não foi possível carregar o mapa.",
    "title": "Tracking",
    "vessel_overlay": { "knots": "knots" },
    "vessels": {
      "card": { "last_updated_at": "Últ. Atual. :. {{ date }}" },
      "empty_list": "Não encontramos nenhum resultado",
      "filters": {
        "search": "Buscar por {{ params }}",
        "search_params": {
          "air": "Avião, processo",
          "maritime": "Navio, Container, Processo",
          "road": "Veículo, Processo",
          "train": "Trem, processo",
          "warehouse": "Armazém, processo"
        },
        "show_own_fleet": "Apenas carga própria"
      }
    }
  },
  "importer_modal": {
    "caption": "Extensões aceitas: XLSX",
    "description": "Use nossa funcionalidade de importação de dados para carregar grandes volumes de informações de maneira simples. Comece baixando o modelo de planilha através do botão abaixo. Este modelo ajuda a preparar seus dados no formato certo. Depois, é só arrastar e soltar a planilha preenchida na área indicada para importar seus dados de forma eficiente.",
    "download_template": "Baixar modelo",
    "import_info": "Importar {{ title }}",
    "order_products": {
      "product_not_found": "Não foi possível encontrar o produto da linha {{ row }} com o código {{ code }}"
    },
    "success": "Importação finalizada com sucesso. \n Linhas importadas com sucesso: {{ importedRows }}",
    "update": "Substituir arquivo",
    "upload": "Adicionar arquivo"
  },
  "info": { "exporting": "📤 Exportando..." },
  "input_select": {
    "interaction_hint": "Digite para buscar",
    "no_options_select": "Nenhuma opção encontrada",
    "searching": "Realizando busca...",
    "not_found": "Dados não encontrados para"
  },
  "insight_indicator": {
    "tooltip_title_one": "{{count}} insight identificado",
    "tooltip_title_other": "{{count}} insights identificados"
  },
  "insights": {
    "title": "Insights",
    "group_by": {
      "none": "Todos",
      "category": "Por categoria",
      "analysis": "Por análise",
      "rule": "Por regra",
      "entityType": "Por tipo de entidade",
      "entity": "Por entidade"
    },
    "filters": {
      "title": "Filtros",
      "clear": "Limpar",
      "active_label": "Ativos:",
      "sections": { "category": "Categoria", "analysis": "Análise", "rule": "Regra", "entity_type": "Tipo de entidade" }
    },
    "toolbar": {
      "heading": "Insights",
      "meta_summary": "{{insightCount}} insights · {{categoryCount}} categorias · {{entityCount}} entidades",
      "meta_summary_no_entity": "{{insightCount}} insights · {{categoryCount}} categorias",
      "search_placeholder": "Buscar insight...",
      "entity_search_placeholder": "Buscar entidade...",
      "clear_all": "Limpar",
      "expand_all": "Expandir todos",
      "collapse_all": "Recolher todos"
    },
    "common": { "all": "Todos", "expand": "Expandir", "collapse": "Recolher" },
    "dashboard": {
      "empty_state": "Nenhum insight encontrado com estes filtros.",
      "insights_in_section_one": "{{count}} insight",
      "insights_in_section_other": "{{count}} insights",
      "entity_type_unknown": "Desconhecido"
    },
    "card": {
      "feedback_great": "Arrasou!",
      "feedback_relevant": "Relevante",
      "feedback_irrelevant": "Irrelevante",
      "evidences": "Evidências",
      "evidence_null": "nulo",
      "date_first_seen": "Primeiro registro",
      "date_last_seen": "Último registro"
    },
    "lifecycle": {
      "acknowledged": "Resolvido",
      "dismissed": "Não relevante",
      "acknowledge_tooltip": "Resolvido — tratado e concluído",
      "dismiss_tooltip": "Marcar como não relevante",
      "dismiss_feedback_title": "Feedback enviado",
      "dismiss_feedback_none": "Descartado sem um motivo"
    },
    "feedback": {
      "title": "Por que não é relevante?",
      "subtitle": "Seu feedback treina o modelo que gera os insights.",
      "comment_placeholder": "O que tornou este insight incorreto? (opcional)",
      "submit": "Enviar feedback",
      "skip": "Descartar sem motivo",
      "error": "Não foi possível salvar seu feedback. Tente novamente.",
      "reasons": {
        "false_positive": "Falso positivo — não é um problema real",
        "irrelevant": "Irrelevante para este processo",
        "incorrect_info": "Informação incorreta ou desatualizada",
        "duplicate": "Duplicado de outro insight"
      }
    },
    "run_audit": {
      "button": "Executar auditoria",
      "cooldown_minutes": "{{minutes}} min",
      "cooldown_tooltip": "Última auditoria em {{lastRun}}. Você poderá rodar novamente em {{minutes}} min.",
      "cooldown_tooltip_no_last": "Você poderá rodar novamente em {{minutes}} min.",
      "running_title": "Auditoria em andamento",
      "running_subtitle": "Analisando o processo em busca de divergências, inconsistências e pontos de atenção. Os insights serão exibidos aqui ao final da execução.",
      "running_hint": "Pode levar alguns minutos. Se preferir, volte mais tarde para conferir o resultado.",
      "empty_title": "Nenhuma auditoria executada",
      "empty_subtitle": "Inicie uma auditoria para identificar divergências e pontos de atenção neste processo.",
      "error_title": "Não foi possível carregar o status da auditoria",
      "error_subtitle": "Algo deu errado ao carregar a auditoria deste processo. Tente novamente.",
      "retry": "Tentar novamente"
    }
  },
  "integrations": {
    "api_requests": {
      "filters": {
        "api_keys": "Origem",
        "status_code": { "error": "Erros", "success": "Sucessos" },
        "title": "Filtrar por:"
      },
      "modal": { "title": "Requisição" },
      "operations": { "today": "Hoje" }
    },
    "docs": {
      "api_key": "API Key",
      "no_content": "Não há documentações para serem exibidas.",
      "title": "Docs",
      "download_spec": "Download OpenAPI Spec"
    }
  },
  "json_viewer": {
    "clear_search": "Limpar busca",
    "collapse_all": "Recolher tudo",
    "copy_all": "Copiar tudo",
    "expand_all": "Expandir tudo",
    "items": "itens",
    "keys": "chaves"
  },
  "kanban": { "phase_column": { "order_by": "Ordenação" } },
  "language_switcher": { "en-US": "Inglês-US", "es-ES": "Espanhol", "pt-BR": "Português-BR" },
  "costs": {
    "title": "Custos",
    "tabs": { "aggregated_header": { "processes": "Processos" }, "process": { "title": "Embarques" } },
    "no_content": { "text": "Ainda não há informações por aqui." },
    "header": {
      "model_select_label": "Modelo",
      "reference_date_label": "Referência Data",
      "date_range": { "start_date": "Início", "end_date": "Fim" }
    }
  },
  "lead_times": {
    "configure_lead_times_modal": {
      "create_lead_time_form": {
        "blocked_stages_section": "Para configurar os estágios do seu modelo, por favor selecione quais operações este modelo irá contemplar",
        "example": "Exemplo",
        "example_description": "Se o evento de referência para o seu planejamento for ”Entrega”, durante a criação do processo você irá fornecer uma data planejada para a Entrega. E os demais eventos planejados serão automaticamente calculados em função desta data.",
        "no_dates": "Você ainda não tem datas cadastradas.",
        "no_stages": "Você ainda não tem trechos cadastrados.",
        "reference_event_description": "Defina o evento de referência para o planejamento do processo:",
        "reference_for_planning": "Referência para o planejamento"
      },
      "update_lead_time_model": { "success_message": "Modelo de Lead Time atualizado com sucesso!" },
      "footer": { "submit_button": "Criar modelo", "update_button": "Atualizar modelo" },
      "lead_time_model": {
        "cannot_delete_model": "Não é possível deletar um modelo de Lead Time enquanto ele possuir Lead Times Planejados vinculados. Para isso, exclua os Lead Times Planejados manualmente.",
        "deleted_message": "Modelo de Lead Time excluído com sucesso!",
        "planned_lead_time": {
          "deleted_message": "Lead Time planejado excluído com sucesso!",
          "name": "Nome do lead time planejado",
          "no_content": "Você ainda não tem lead times planejados cadastrados."
        }
      },
      "models_list": { "title": "Modelos" },
      "no_models": "Você ainda não tem modelos cadastrados.",
      "please_select_a_model": "Por favor, selecione um modelo",
      "title": "Configurar Lead Times"
    },
    "header": {
      "no_lead_times_to_export": "Não há Lead Times para exportar",
      "date_range": { "start_date": "Início", "end_date": "Fim" }
    },
    "model_select": { "label": "Modelo" },
    "no_content": { "text": "Nenhum resultado encontrado." },
    "stages": { "at_least_one": "Preencha ao menos um dos campos.", "days": "Dias", "hours": "Horas" },
    "tabs": {
      "aggregated_header": { "deviation": "Desvio", "processes": "Processos", "realized_or_estimated": "LT real/plan" },
      "lead_time": { "by_lead_time": "por_lead_time", "title": "Lead time" },
      "product": { "by_product": "por_produto", "title": "Produto" }
    },
    "title": "Lead Times"
  },
  "location_management_modal": {
    "no_place_found": "Nenhum local encontrado para o interveniente selecionado",
    "select": { "label": "Interveniente" },
    "select_local_to_view_map": "Selecione um endereço para visualizar o mapa.",
    "select_place": "Selecionar Local"
  },
  "lpcos": {
    "drawer": {
      "attachments_documents_section": "Documentos",
      "attachments_dossiers_section": "Dossiês",
      "attachments_empty": "Nenhum anexo vinculado a este LPCO.",
      "attachments_tab": "Anexos",
      "document_status_discarded": "Desconsiderado",
      "document_status_read": "Lido",
      "document_status_unread": "Não lido",
      "field_column": "Campo",
      "form_completion": {
        "boolean": "Booleano",
        "composite": "Composto",
        "date": "Data",
        "date_and_hour": "Data e hora",
        "dynamic_domain": "Domínio dinâmico",
        "list": "Lista de valores",
        "number": "Número",
        "text": "Texto"
      },
      "general_data": "Dados Gerais",
      "general_tab": "Geral",
      "generic_attribute": "Atributo",
      "guidance_title": "Orientação",
      "history_automatic": "Automático",
      "history_changed": "alterado",
      "history_request": "Solicitação",
      "import_indicator_direct": "Importação direta",
      "import_indicator_on_behalf": "Importação por conta e ordem",
      "import_indicator_on_order": "Importação por encomenda",
      "items_list": "Lista de Itens",
      "model": "Modelo",
      "no_dictionary_definition": "Definição não disponível no dicionário de atributos.",
      "not_catalogued": "Não catalogado",
      "possible_values_title_one": "Valor possível ({{count}})",
      "possible_values_title_other": "Valores possíveis ({{count}})",
      "required_attribute": "obrigatório",
      "show_less": "Ver menos",
      "show_more": "Ver mais",
      "value_column": "Valor",
      "validity_expired_one": "Vencido há {{count}} dia",
      "validity_expired_other": "Vencido há {{count}} dias",
      "validity_remaining_one": "Válido por mais {{count}} dia",
      "validity_remaining_other": "Válido por mais {{count}} dias",
      "validity_title": "Vigência"
    },
    "list": {
      "columns": {
        "agency": "Órgão",
        "identification": "Identificação",
        "insights": "Insights",
        "linked_declarations": "DUIMPs / DUEs",
        "model": "Modelo",
        "model_agency": "Modelo / Órgão",
        "status": "Situação",
        "validity": "Vigência"
      },
      "expiry": {
        "days_one": "{{count}} dia",
        "days_other": "{{count}} dias",
        "expired": "Expirado",
        "months_days": "{{months}}m {{days}}d",
        "months_one": "{{count}} mês",
        "months_other": "{{count}} meses",
        "suffix": "p/ expirar",
        "today": "Hoje",
        "years_months": "{{years}}a {{months}}m",
        "years_one": "{{count}} ano",
        "years_other": "{{count}} anos"
      },
      "filters": { "insights": "Insights", "no_agency_options": "Nenhum órgão disponível nesta página" },
      "not_linked": "Não vinculada",
      "page_title": "LPCOs",
      "result_count_one": "{{count}} resultado",
      "result_count_other": "{{count}} resultados",
      "search_placeholder": "Buscar nº do LPCO…",
      "title": "LPCO",
      "view_action": "Visualizar LPCO"
    }
  },
  "maritime_transport": {
    "mercante": {
      "datagrid": { "end_date": "Fim (ETB)", "start_date": "Início (ETB)", "vessel_country": "Bandeira da Embarcação" },
      "title": "Escalas Mercante"
    }
  },
  "modals": {
    "batch_update": {
      "automatic_tracking_alert": "Os processos <strong>{{ referenceCodes }}</strong> possuem Tracking automático ativo. Ao salvar, ele será desativado para esses processos.",
      "btn_label": "Atualizar",
      "components": {
        "field_select": "Campos",
        "preview_table": { "empty": "Sem dados alterados", "title": "Campos alterados" },
        "process_alert": "Por favor, selecione pelo menos um processo",
        "process_list_title": "Processos a serem alterados"
      },
      "title": "Atualização em lote",
      "update_success": "Processos atualizados com sucesso"
    },
    "create_automation": { "title": "Criar automação" },
    "create_order": { "create_btn": "Criar Pedido", "success": "Pedido criado com sucesso!", "title": "Novo Pedido" },
    "create_process": {
      "add_to_process": "Adicionar ao Processo",
      "alert_add_to_process_more": "Você adicionou {{ productsAdded }} produtos ao processo",
      "alert_add_to_process_one": "Você adicionou 1 produto ao processo",
      "create_btn": "Criar Processo",
      "error": {
        "missing_products_to_orders": "Para criar o processo, adicione produtos de todos os Pedidos",
        "order_ids": "Selecione ao menos um pedido",
        "product_items": "Adicione ao menos um produto a este processo",
        "reference_code": "Preencha o nº de Processo",
        "required_lead_time_datetime_reference": "Selecione uma data de referência para o Lead Time Planejado",
        "shipment_modal_type": "Selecione um modal de transporte"
      },
      "link_lead_time": { "form": { "datetime_reference": "[{{referenceEvent}}] planejado" } },
      "link_orders": { "label": "Pedido", "placeholder": "Selecione os pedidos", "searching": "Buscando pedidos..." },
      "orders": { "title": "Pedidos" },
      "process_content": { "title": "Lista de Produtos" },
      "shipment_type": { "title": "Modal de Transporte" },
      "submit_process": "Criar Processo",
      "success": "Processo criado com sucesso!",
      "table": { "order_total": "Total do pedido", "this_process": "Neste processo" },
      "title": "Novo Processo"
    },
    "location_creation": {
      "address_search": "Pesquisar endereço",
      "new_address": "Novo Endereço",
      "search_for_a_address_to_continue": "Pesquise um endereço para continuar",
      "success": "Local cadastrado com sucesso!",
      "title": "Criar Novo Endereço",
      "waiting_address": "Aguardando endereço..."
    },
    "location_deletion": {
      "cannot_remove_address": "Não é possível remover endereços atribuídos a uma rota",
      "description": "Você tem certeza que deseja remover este endereço? Essa ação não poderá ser desfeita.",
      "success": "Endereço removido com sucesso!",
      "title": "Remover Endereço"
    },
    "location_edit": { "success": "Endereço alterado com sucesso!", "title": "Editar Endereço" },
    "order_creations": {
      "create": "Criar",
      "title": "Pedido de Transporte",
      "toast_messages": {
        "error_especific_handler": "Selecione um {{handler}}",
        "error_reference_code": "Preencha a referência",
        "error_road_transport_order": "Preencha os dados do pedido",
        "error_road_transport_order_type": "Preencha o tipo do pedido",
        "route": "Selecione uma rota",
        "success": "✅  Pedido criado com sucesso!"
      }
    },
    "update_order": {
      "reset_changes_btn": "Descartar Alterações",
      "success": "Pedido atualizado com sucesso!",
      "update_btn": "Atualizar Pedido"
    },
    "confirm_cost_close": {
      "title": "Fechar Custo",
      "description_with_planned": "Você tem certeza que deseja fechar este custo? Essa ação irá pausar a propagação dos custos planejados e impossibilitará a atualização dos realizados.",
      "description": "Você tem certeza que deseja fechar este custo? Essa ação impossibilitará a atualização dos custos realizados."
    },
    "confirm_update_process_cost_model_version": {
      "title": "Alterar Versão do Modelo de Custos",
      "description": "Você tem certeza de que deseja alterar esta versão do modelo de custos? Essa ação removerá os custos realizados da versão atual."
    },
    "confirm_cost_reopen": {
      "title": "Reabrir Custo",
      "description": "Você tem certeza que deseja reabrir este custo?"
    }
  },
  "not_authorized": {
    "description": "Desculpe, você não possui acesso a este recurso.",
    "go_to_home": "Voltar ao início",
    "title": "Não autorizado"
  },
  "operation_trash": {
    "modal": {
      "description": "Ao clicar em confirmar, o item recuperado estará disponível para visualização dentro da operação",
      "title": "Recuperar {{entity}} {{reference_code}}?"
    },
    "tabs": { "orders": "Pedidos", "processes": "Processos" },
    "title": "Lixeira"
  },
  "container_components": { "create_form": { "sections": { "washing": "Lavagem do Container" } } },
  "operations": {
    "export_excel": "Exportar Planilha",
    "exporting_data_sheet": "Exportando planilha de dados...",
    "exporting_excel": "Exportando...",
    "exporting_excel_success": "Planilha exportada com sucesso!",
    "exporting_excel_error": "Erro ao exportar planilha. Por favor, tente novamente mais tarde.",
    "new_process": "Novo Processo",
    "phases": { "FINISHED": "Finalizado" },
    "quick_filters": {
      "filter_options_column": {
        "empty_filtered_results_text": "Nenhum resultado encontrado.",
        "search_input_label": "Filtrar",
        "is_empty": "É vazio",
        "is_not_empty": "Não vazio"
      },
      "title": "Filtros Rápidos"
    },
    "tabs": { "kanban": "Kanban", "lead_times": "Lead Times", "table": "Tabela", "costs": "Custos" },
    "title": "Operações"
  },
  "operations_table": { "title": "Tabela" },
  "order_components": {
    "product_list_form": {
      "fields": { "sku": "SKU" },
      "product_divergence": {
        "alerts_column": "Alertas",
        "columns": { "field": "Campo", "order": "Pedido", "product": "Cadastro" },
        "fields": { "description": "Descrição", "mercosulCode": "NCM", "translatedDescriptions": "Traduções" },
        "force_sync": "Forçar atualização",
        "force_sync_description": "Forçar a atualização substitui o NCM, a descrição e as traduções do item do pedido pelos dados do cadastro vigente do produto. A alteração só é aplicada após salvar o pedido.",
        "force_sync_success": "Item atualizado. Salve o pedido para aplicar a alteração.",
        "pending_sync": "Alteração pendente de salvar",
        "title": "Divergência com o cadastro"
      },
      "sections": {
        "adjusted_lead_time": "Lead Time - Ajustado",
        "administrative_treatment": "Tratamento Administrativo",
        "customs": "Desembaraço",
        "default_lead_time": "Lead Time - Padrão",
        "delivery": "Entrega",
        "item_status": "Status Item",
        "invoice": "Invoice",
        "note": "Observações",
        "order": "Pedido",
        "planning": "Planejamento",
        "product": "Produto",
        "shipment": "Embarque",
        "stock": "Estoque",
        "supplier": "Fornecedor",
        "tax_treatment": "Tratamento Tributário"
      }
    }
  },
  "order_modal": {
    "actions_menu": {
      "cancel_order_with_processes": "Deseja cancelar o pedido e todos os processos vinculados a ele?",
      "cancel_order": "Cancelar Pedido",
      "delete_order_with_processes": "Deseja deletar o pedido e todos os processos vinculados a ele?",
      "delete_order": "Deletar Pedido",
      "disallow_cancel_order": "Não é possível cancelar este pedido enquanto algum de seus processos estiver vinculado a outros pedidos. Para isso, cancele/delete os processos manualmente.",
      "disallow_delete_order": "Não é possível deletar este pedido enquanto algum de seus processos estiver vinculado a outros pedidos. Para isso, delete os processos manualmente.",
      "disallow_finish_order": "Não é possível finalizar este pedido enquanto algum de seus processos estiver abertos. Para isso, finalize  os processos manualmente.",
      "enter_the_reference_code": "Insira o Código de Referência do pedido para continuar.",
      "finish_order": "Finalizar Pedido",
      "reference_code": "Código de Referência",
      "unfinish_order": "Reabrir Pedido"
    },
    "cancel": "Pedido cancelado com sucesso!",
    "delete": "Pedido excluído com sucesso!",
    "extra_subform": "Campos adicionais",
    "finish_order_confirmation_description": "Deseja finalizar o Pedido?",
    "unfinish_order_confirmation_description": "Deseja reabrir o Pedido?",
    "finish_order_confirmation_title": "Finalização de Pedido",
    "unfinish_order_confirmation_title": "Reabertura de Pedido",
    "finish_order_error": "Não foi possível finalizar o Pedido.",
    "unfinish_order_error": "Não foi possível reabrir o Pedido.",
    "finish_order_success": "Pedido finalizado com sucesso!",
    "unfinish_order_success": "Pedido reaberto com sucesso!",
    "save": "Salvar Alterações",
    "success": "Alterações salvas com sucesso!",
    "tabs": { "order_data": "Dados do Pedido", "pdf_documents": "Documentos PDF", "processes": "Processos" }
  },
  "pdf_documents": { "no_content": "Não há Documentos PDF configurados para essa operação." },
  "process": {
    "checkpoints_processes": {
      "processes": "Processos: {{total}} | Abertos: {{opened}} | Fechados: {{finished}}",
      "waiting": "Aguardando Processo"
    }
  },
  "process_components": {
    "booking_quotation": {
      "title": "Cotação de booking",
      "not_started": "Não iniciada",
      "freight_agents": "Agentes de carga",
      "no_agents": "Nenhum agente de carga no grupo de notificação da página de cotação",
      "documents": "Documentos do processo a enviar",
      "search_document": "Buscar documento do processo",
      "documents_selected": "{{selected}} de {{total}} selecionados",
      "closes_at": "Data-hora de encerramento ({{timezone}})",
      "documents_hint": "Ficam disponíveis no link de cada agente",
      "period_preview": "Duração prevista",
      "send": "Enviar a cotação",
      "sent": "Cotação enviada aos agentes",
      "save_before_send": "Salve as alterações antes de enviar a cotação",
      "view_draft": "Ver rascunho",
      "review": "Revisar",
      "preview_title": "Rascunho da cotação",
      "confirm_send_title": "Confirmar envio da cotação",
      "opened_at": "Aberta em {{date}} ({{timezone}})",
      "cancellation_reason": "Motivo do cancelamento: {{reason}}",
      "cancel": "Cancelar cotação",
      "cancel_confirm_description": "A cotação {{reference}} será encerrada sem vencedor. As propostas recebidas ficam arquivadas e os links deixam de aceitar envios.",
      "cancel_reason_label": "Motivo (opcional)",
      "cancel_reason_placeholder": "Ex.: embarque adiado pelo cliente",
      "cancel_notified": "Serão avisados por e-mail",
      "canceled": "Cotação cancelada",
      "sealed": {
        "title": "Propostas em sigilo até o encerramento",
        "description": "Nenhum valor é visível antes do fim do período. Todas as propostas abrem ao mesmo tempo."
      },
      "closes_at_short": "encerra {{date}} ({{timezone}})",
      "responded_count": "<strong>{{responded}}</strong> de {{invited}} responderam",
      "values_hidden": "valores ocultos",
      "last_updated_at": "Atualizada {{date}}",
      "decline_reason": "Motivo: {{reason}}",
      "reopen": "Reabrir cotação",
      "reopen_with_new_agents": "Reabrir com novos agentes",
      "round": "{{round}}ª rodada",
      "reopen_dialog": {
        "closed_at": "Encerrada {{date}}",
        "responded": "{{responded}} de {{invited}} responderam",
        "viewed_alert": "As propostas da {{round}}ª rodada já foram visualizadas. Novas propostas e edições voltam ao sigilo até o novo encerramento.",
        "add_agent": "Adicionar agente",
        "select_agent": "Selecionar agente",
        "remove_agent": "Remover agente",
        "new": "Novo",
        "locked": "{{status}} · não pode ser removido",
        "proposals_title": "Propostas da {{round}}ª rodada",
        "keep": {
          "title": "Manter propostas",
          "description": "Quem respondeu pode editar a proposta até o novo prazo. Quem não respondeu ganha nova chance.",
          "notifies": "Notifica: prazo estendido"
        },
        "restart": {
          "title": "Reiniciar do zero",
          "description_one": "A {{count}} proposta recebida ({{agents}}) será descartada. Todos os agentes enviam novamente.",
          "description_other": "As {{count}} propostas recebidas ({{agents}}) serão descartadas. Todos os agentes enviam novamente.",
          "notifies": "Notifica: revisão solicitada"
        },
        "agents_count_one": "{{count}} agente",
        "agents_count_other": "{{count}} agentes",
        "closes_at": "Nova data-hora de encerramento ({{timezone}})",
        "notified_keep_one": "{{count}} agente será notificado — novo prazo: {{extended}} · novo convite: {{invites}}",
        "notified_keep_other": "{{count}} agentes serão notificados — novo prazo: {{extended}} · novo convite: {{invites}}",
        "notified_restart_one": "{{count}} agente será notificado — revisão solicitada: {{revision}} · novo convite: {{invites}}",
        "notified_restart_other": "{{count}} agentes serão notificados — revisão solicitada: {{revision}} · novo convite: {{invites}}",
        "success": "Cotação reaberta"
      },
      "closed_at": "Encerrada em {{date}} ({{timezone}}) · {{responded}} de {{invited}} responderam",
      "compare": {
        "button": "Comparar propostas",
        "title": "Comparar propostas",
        "responded": "{{responded}} de {{invited}} responderam",
        "proposals_count_one": "{{count}} proposta",
        "proposals_count_other": "{{count}} propostas",
        "closed_at": "encerrada {{date}}",
        "export": "Exportar Excel",
        "export_error": "Não foi possível exportar o comparativo",
        "sections": {
          "conditions": "Condições",
          "origin": "Origem",
          "international": "Internacional",
          "destination": "Destino"
        },
        "labels": { "transit_time": "Transit time", "representativeness": "% representatividade" },
        "transit_days_one": "{{count}} dia",
        "transit_days_other": "{{count}} dias",
        "proposal_label": "Proposta {{index}}",
        "sent_at": "Enviada {{date}}",
        "edited_at": "Editada {{date}}",
        "lowest_cost": "Menor custo",
        "representativeness_tooltip": "Percentual do custo total da proposta sobre o valor final das Invoices — base de {{value}}.",
        "attachments": "Anexos",
        "attachments_count_one": "{{count}} anexo",
        "attachments_count_other": "{{count}} anexos",
        "name_winner": "Nomear vencedor",
        "file_name": "comparativo_propostas",
        "footer_hint": "Clique em um agente para abrir o detalhe da proposta e os anexos.",
        "close": "Fechar",
        "empty": "Nenhuma proposta enviada",
        "proposal": "Proposta",
        "total": "Total",
        "view_details": "Ver detalhes",
        "list_footer": "Comparativo completo e anexos de cada proposta abrem em tela dedicada."
      },
      "proposal_drawer": {
        "proposal": "Proposta · {{number}}",
        "sent_at": "Enviada em",
        "edited_at": "Editada em",
        "summary": "Resumo",
        "goods_value_percent": "% do valor da mercadoria",
        "route": "Carregamento → Descarregamento",
        "values": "Valores",
        "total": "Total da proposta",
        "total_hint": "Soma dos seis fatores informados pelo agente"
      },
      "snapshot_changes": {
        "title": "Dados do processo alterados após o envio",
        "description": "Os agentes convidados cotaram com os valores anteriores e podem precisar revisar as propostas."
      },
      "name_winner": {
        "title": "Nomear vencedor",
        "description": "Nomear <strong>{{agent}}</strong> como vencedora da cotação {{reference}}? Esta ação é irreversível.",
        "total": "Total da proposta",
        "sealine_route": "Sealine · Portos",
        "collection_notes": "Observações para a coleta (opcional)",
        "collection_notes_placeholder": "Ex.: local, horário e contato para a coleta",
        "on_confirm": "Ao confirmar",
        "confirmation_email": "E-mail de <strong>confirmação</strong> enviado à vencedora",
        "thanks_email": "E-mail de <strong>agradecimento</strong> enviado aos demais participantes",
        "confirm": "Nomear vencedor",
        "success": "Vencedor nomeado"
      },
      "winner": {
        "banner": "{{agent}} foi nomeada vencedora",
        "badge": "Proposta vencedora",
        "route": "Carregamento → Descarregamento",
        "awaiting_booking": "Aguardando dados do booking",
        "link_sent_at": "Link enviado em {{date}}",
        "booking_received": "Dados do booking recebidos",
        "received_at": "Enviado em {{date}}",
        "resend_link": "Reenviar link de booking",
        "resend_success": "Link de booking reenviado",
        "automations": "Automações disparadas",
        "confirmation_sent": "E-mail de <strong>confirmação</strong> enviado à {{agents}}",
        "thanks_sent": "E-mail de <strong>agradecimento</strong> enviado a {{agents}}"
      }
    },
    "demurrage": {
      "sections": { "container": "Container", "demurrage": "Demurrage", "payments": "Pagamentos", "status": "Status" }
    },
    "deadlines": {
      "title": "Programação de Navios",
      "subtitle": "Exportação",
      "dates": {
        "draft": { "title": "Deadline DRAFT", "subtitle": "Shipping Instructions" },
        "vgm": { "title": "Deadline VGM", "subtitle": "Verified Gross Mass" },
        "gate": { "title": "GATE", "subtitle": "Abertura Gate" },
        "cargo": { "title": "Deadline CARGA", "subtitle": "Carga" }
      },
      "reference_popper": {
        "title": "Alterar Referência",
        "description": "Nota: O modo auto seleciona automaticamente a data mais restritiva entre as disponíveis.",
        "select": "Selecionar"
      },
      "table": { "last_search": "Última consulta" },
      "alert_status": {
        "not_found": "Dados não encontrados para esse Navio e Viagem",
        "pending": "Aguardando dados",
        "invalid": "Dados inválidos",
        "sealine_not_supported": "Ainda não possuímos integração com esse Armador para Programação de Navios"
      }
    }
  },
  "process_modal": {
    "actions_menu": {
      "cancel_process": "Cancelar Processo",
      "delete_process": "Deletar Processo",
      "enter_the_reference_code": "Insira o Código de Referência do processo para continuar.",
      "finish_process": "Finalizar Processo",
      "unfinish_process": "Reabrir Processo"
    },
    "cancel": "Processo cancelado com sucesso!",
    "cargo_information": { "fields": { "cargo_type": "Tipo de carga" }, "title": "Informações da carga" },
    "insights": { "tab": "Insights" },
    "costs": {
      "tab": "Custos",
      "deviation": "Desvio",
      "planned": "Planejado",
      "realized": "Realizado",
      "average": "Média",
      "per_reference": {
        "informations": { "expenses": "Despesas" },
        "titles": {
          "BRAZILIAN_INVOICE_VALUE": "Valor da Nota Fiscal",
          "CALCULATED_CUBAGE_CUBIC_METERS": "Volume Calculado",
          "CALCULATED_GROSS_WEIGHT_KG": "Peso Bruto Calculado",
          "GROSS_WEIGHT_KG": "Peso Bruto",
          "QUANTITY": "Quantidade"
        }
      },
      "tabs": { "product": "Por Produto", "shipment": "Por Embarque", "per_reference": "Cálculos Unitários" },
      "update": { "success": "Custo salvo com sucesso" },
      "toolbar": {
        "export": "Exportar",
        "export_error": "Erro ao exportar custos. Por favor, tente novamente mais tarde.",
        "export_loading": "Exportando...",
        "expand": "Expandir",
        "filter_items": "Filtrar Produtos",
        "collapse": "Recolher",
        "close_cost": "Fechar Custo",
        "reopen_cost": "Reabrir Custo",
        "export_columns": {
          "cost": "Despesa",
          "deviation": "Desvio",
          "group": "Grupo",
          "planned_cost": "Planejado",
          "precification_model": "Modelo de Precificação",
          "product": "Produto",
          "realized": "Realizado",
          "reference_product_prorated": "Referência do Rateio",
          "reference_value": "Valor de Referência",
          "reference": "Referência",
          "sub_group": "Subgrupo",
          "total_deviation": "Total Desvio",
          "total_planned_cost": "Total Planejado",
          "total_realized": "Total Realizado",
          "uniqueness": "Unicidade",
          "unitary_deviation": "Valor Unitário Desvio",
          "unitary_planned_cost": "Valor Unitário Planejado",
          "unitary_realized": "Valor Unitário Realizado"
        }
      },
      "totals": { "title": "TOTAL", "reference": "Embarque" }
    },
    "delete": "Processo excluído com sucesso!",
    "finish_process_confirmation_description": "Deseja finalizar o processo?",
    "unfinish_process_confirmation_description": "Deseja reabrir o processo?",
    "finish_process_confirmation_title": "Finalização de Processo",
    "unfinish_process_confirmation_title": "Reabertura de Processo",
    "finish_process_error": "Não foi possível finalizar o processo.",
    "unfinish_process_error": "Não foi possível reabrir o processo.",
    "finish_process_success": "Processo finalizado com sucesso!",
    "unfinish_process_success": "Processo reaberto com sucesso!",
    "history": {
      "changes": { "types": { "insert": "Criação", "delete": "Remoção", "update": "Atualização" } },
      "no_content_message": "Não existem mudanças neste processo",
      "title": "Histórico de mudanças"
    },
    "lead_time": {
      "conclusion_date": "Data de conclusão",
      "no_content": "Não há Lead Time vinculado",
      "error_content": "Erro ao calcular lead times previstos, verifique as datas inseridas.",
      "preview_conclusion_date": "Data de conclusão prevista",
      "status": { "ADVANCED": "Adiantado {{time}}", "LATE": "Atrasada {{time}}", "ON_TIME": "On Time" },
      "timeline": {
        "titles": { "deviance": "Desvio", "planned": "Planejado", "realized": "Realizado/Previsto" },
        "today": "Hoje"
      },
      "errors": {
        "realized": "Realizado",
        "estimated": "Previsto",
        "planned": "Planejado",
        "dates": "Datas",
        "lead_time": "Lead Time"
      },
      "update": { "success": "Lead Time salvo com sucesso" }
    },
    "process_not_found": "Processo não encontrado.",
    "process_unauthorized": "Você não tem permissão para acessar este processo.",
    "reset_changes_btn": "Descartar Alterações",
    "reset_changes_confirmation_description": "As alterações não salvas serão descartadas. Deseja continuar?",
    "reset_changes_confirmation_title": "Descartar Alterações",
    "restored": "Item restaurado com sucesso!",
    "save": "Salvar Alterações",
    "success": "Alterações salvas com sucesso!"
  },
  "products": {
    "edit_products": {
      "page_title": "Editar Produto",
      "save": "Salvar",
      "success": "Produto alterado com sucesso",
      "title": "Editar Produto"
    },
    "product_drawer": { "title": "Detalhes do Produto" },
    "products_form": {
      "package_levels": "Níveis de Embalagem",
      "package": "Embalagem e Logística",
      "primary_package": "Embalagem Primária",
      "product_characteristics": "Características do Produto",
      "product_data": "Dados do Produto",
      "success": "Produto adicionado com sucesso",
      "popover_info": {
        "title": "Informações",
        "package_data": {
          "conclusion": "Esses níveis ajudam a representar melhor o produto na cadeia logística e facilitam o planejamento e os cálculos de transporte e custos.",
          "example_title": "Você pode detalhar com mais níveis de embalagem opcionais:",
          "info": "A Embalagem Primária é a unidade base de cadastro, utilizada como referência para quantidade do produto na criação dos processos.",
          "examples": {
            "containerization": "Containerização (ex: pallets no container)",
            "content": "Conteúdo (ex: garrafa)",
            "multiple": "Unitização (ex: caixas dentro de caixa maior)",
            "palletization": "Paletização (ex: caixas sobre pallet)"
          }
        }
      }
    },
    "products_list": {
      "add_new": "Adicionar Produto",
      "archive_confirm_description": "O produto será arquivado e removido da lista ativa. Deseja prosseguir?",
      "archive_confirm_title": "Arquivar produto?",
      "page_title": "Produtos",
      "product_archived": "Produto arquivado com sucesso!",
      "title": "Produtos"
    },
    "products_new": { "page_title": "Cadastrar Produto", "title": "Cadastrar Produto" }
  },
  "report_columns": {
    "shared": {
      "automatic": "Automático",
      "deviation_days": "Desvio",
      "manual": "Manual",
      "operation_name": "Operação",
      "reference_code": "Cód. Referência",
      "tracking_mode": "Modo Tracking",
      "tracking_status": "Status Tracking"
    },
    "shipment_containers": "Containers Embarque",
    "realized_at": "Realizado"
  },
  "quick_filters": { "active_label": "Ativos:", "clear": "Limpar" },
  "reports": {
    "add_new": "Criar relatório",
    "delete": {
      "success_message": "Relatório excluído com sucesso",
      "title": "Você tem certeza que deseja excluir o relatório {{ reportName }}?"
    },
    "edit_report_modal": { "success": "Relatório alterado com sucesso", "title": "Editar relatório" },
    "new_report_modal": { "success": "Relatório criado com sucesso", "title": "Criar novo relatório" },
    "refresh": "Atualizar",
    "report_changes": {
      "save": "Salvar Relatório",
      "success": "Relatório salvo com sucesso",
      "title": "Este relatório possui alterações que ainda não foram salvas.",
      "revert": "Reverter alterações"
    },
    "report_modal": { "name_field": "Nome do Relatório" },
    "select_report": "Relatório",
    "table": { "no_content": "Nenhum relatório para ser exibido" },
    "export": {
      "success_message": "O relatório está sendo processado em segundo plano. Você pode navegar em outras páginas enquanto isso"
    },
    "duplicate_report_modal": {
      "title": "Duplicar relatório",
      "success": "Relatório duplicado com sucesso",
      "unsaved_changes_tooltip": "Existem alterações não salvas"
    }
  },
  "routes": {
    "edit_route": { "page_title": "Editar Rota" },
    "new_route": {
      "actions": {
        "add_event": "Adicionar evento",
        "add_local": "Adicionar local",
        "add_route": "Adicionar rota",
        "edit_local": "Editar local",
        "remove_event": "Remover evento",
        "remove_local": "Remover local"
      },
      "page_title": "Nova Rota"
    },
    "route_form": {
      "add_local": "Adicione locais aos eventos para visualizar o mapa.",
      "road_transport": "Transporte Rodoviário",
      "route_data": "Dados da Rota",
      "successfully_created": "Rota criada com sucesso!",
      "successfully_updated": "{{routeName}} atualizada com sucesso!"
    },
    "routes_list": {
      "page_title": "Rotas",
      "route_deleted_successfully": "Rota excluída com sucesso!",
      "table": { "active": "ATIVO", "inactive": "INATIVO", "status": "Status" }
    }
  },
  "search": { "location_placeholder": "Pesquisar Endereço", "placeholder": "Buscar..." },
  "select_workspace": { "loading": "Carregando workspaces...", "title": "Selecione seu workspace", "search": "Buscar" },
  "settings": {
    "credentials": {
      "credential_modal": {
        "create_success": "Credencial criada com sucesso!",
        "delete_success": "Credencial removida com sucesso!",
        "edit_credential": "Editar Credencial",
        "expired_at": "Expirado em:",
        "expires_at": "Válido até:",
        "new_credential": "Nova Credencial",
        "password": "Senha",
        "update_file": "Atualizar Arquivo",
        "update_success": "Credencial atualizada com sucesso!",
        "username": "Username"
      },
      "credential_types": "Tipos de Credenciais",
      "no_credentials": "Não há credenciais para serem exibidas.",
      "search": "Busca",
      "title": "Credenciais"
    },
    "general_data": {
      "card_size_description": "Com essa opção, os cards ficam menores e ocupam menos espaço vertical de tela.",
      "date_format": "Formato de data",
      "language_and_regional_settings": "Idioma & Configurações regionais",
      "success": "Dados gerais atualizados com sucesso!",
      "time_format": "Formato de hora"
    },
    "notification_groups": {
      "add_recipient_success": "Destinatário adicionado com sucesso!",
      "create_success": "Grupo de notificação criado com sucesso!",
      "delete_recipient_success": "Destinatário removido com sucesso!",
      "update_recipient_success": "Destinatário atualizado com sucesso!",
      "recipient_modal": {
        "add_recipient": "Adicionar destinatário",
        "edit_recipient": "Editar destinatário",
        "title": "Gerenciar destinatários",
        "language": "Idioma",
        "manage_recipients": "Gerenciar destinatários",
        "no_recipients": "Nenhum destinatário para este papel",
        "no_roles": "Nenhum papel configurado neste grupo",
        "partnership": "Parceiro"
      },
      "delete_success": "Grupo de notificação removido com sucesso!",
      "form": {
        "create_button": "Criar grupo",
        "create_title": "Novo grupo de notificação",
        "edit_button": "Salvar alterações",
        "edit_title": "Editar grupo de notificação"
      },
      "new_group": "Novo Grupo",
      "title": "Grupos de Notificação",
      "update_success": "Grupo de notificação atualizado com sucesso!"
    },
    "tabs": {
      "credentials": "Credenciais",
      "general_data": "Dados Gerais",
      "notification_groups": "Grupos de Notificação",
      "users": "Usuários",
      "workspace": "Workspace"
    },
    "title": "Configurações",
    "users": {
      "create_success": "Usuário criado com sucesso!",
      "delete_success": "Usuário deletado com sucesso!",
      "edit": { "button_confirm": "Editar usuário", "title": "Editar usuário" },
      "export": { "filename": "ListaUsuarios" },
      "new": { "button_confirm": "Criar usuário", "title": "Novo usuário" },
      "table": { "last_login_without_data": "Sem acesso prévio" },
      "update_success": "Usuário atualizado com sucesso!",
      "search_field_error": "A busca deve conter {{minLength}} ou mais caracteres"
    },
    "workspace": {
      "document_type_label": { "default": "Documento Oficial" },
      "image_upload": { "caption": "Extensões: PNG, JPG, e SVG", "update": "Editar Logo", "upload": "Adicionar Logo" },
      "success": "Dados do workspace alterados com sucesso!"
    }
  },
  "sidebar": {
    "actors": "Intervenientes",
    "agents_executions": "Execuções",
    "agents": "Agentes",
    "booking_quotations": "Cotações",
    "docs": "Documentação da API",
    "documents": "Documentos",
    "drivers": "Motoristas",
    "insights": "Insights",
    "integration_logs": "Logs de Integrações",
    "integrations": "Integrações",
    "lpcos": "LPCOs",
    "maritime_transport": "Transporte Marítimo",
    "mercante": "Mercante",
    "new_agent": "Novo Agente",
    "operations": "Operações",
    "port_terminals": "Terminais Portuários",
    "products": "Produtos",
    "road_transport": "Transporte Rodoviário",
    "routes": "Rotas",
    "settings": "Configurações",
    "sign_out": "Encerrar sessão",
    "support": "Suporte",
    "switch_workspace": "Alterar workspace",
    "tracking": "Tracking",
    "trailers": "Reboques",
    "vehicles": "Veículos"
  },
  "siscomex_product": {
    "drawer": {
      "attributes_section": "Atributos preenchidos",
      "created_at": "Criado em",
      "not_synced": "Produto ainda não sincronizado com o Catálogo do Siscomex.",
      "summary_section": "Resumo",
      "title": "Siscomex · Catálogo de Produtos"
    }
  },
  "siscomex_sync": {
    "rows": {
      "connector": "Conector",
      "entity": "Entidade",
      "in_progress": "em andamento",
      "inserted_at": "Inserido em",
      "last_sync": "Última sincronização"
    },
    "rate_limited": "Só é possível forçar a sincronização a cada 60 segundos. Tente novamente em breve.",
    "sync_now": "Sincronizar agora",
    "syncing_title": "Sincronizando"
  },
  "subscription_update_snackbar": {
    "order": {
      "description": "Deseja atualizar o pedido com as modificações mais recentes? Suas alterações podem ser sobrescritas pela atualização.",
      "title": "Houve alterações no pedido",
      "update_button": "Atualizar Pedido",
      "updated_message": "Houve alterações no pedido e o pedido foi atualizado automaticamente."
    },
    "process": {
      "description": "Deseja atualizar o processo com as modificações mais recentes? Suas alterações podem ser sobrescritas pela atualização.",
      "title": "Houve alterações no processo",
      "update_button": "Atualizar Processo",
      "updated_message": "Houve alterações no processo e o processo foi atualizado automaticamente."
    }
  },
  "trailers": {
    "edit_trailer": { "page_title": "Editar Reboque", "success": "Reboque editado com sucesso" },
    "new_trailer": {
      "form_fields": { "without_tracker": "Não possui rastreador" },
      "page_title": "Cadastrar Reboque",
      "success": "Reboque adicionado com sucesso"
    },
    "trailers_list": {
      "add_new_trailer": "Adicionar reboque",
      "page_title": "Reboques",
      "table": { "tracking": "Rastreador" },
      "trailer_deleted": "Reboque excluído com sucesso!"
    }
  },
  "trip": {
    "containers": "Transporte de Containers",
    "tracking": {
      "client_arrival_at": "Chegada no Cliente",
      "client_departure_at": "Saída do Cliente",
      "end_at": "Fim da Viagem",
      "invoice_exchange_end_at": "Saída da Troca de NF",
      "invoice_exchange_start_at": "Chegada Troca de NF",
      "start_at": "Início Viagem",
      "title": "Tracking"
    }
  },
  "unsaved_dialog": {
    "description": "Tem certeza de que deseja descartar essas alterações?",
    "title": "Alterações não salvas"
  },
  "upload_file_order": {
    "addNew": "Upload de arquivo(s)",
    "btnSalvar": "Salvar",
    "buttonUpload": "Adicionar novo arquivo",
    "selectFiles": "Selecione o tipo do arquivo",
    "success": "Arquivo removido com sucesso"
  },
  "vehicles": {
    "edit_vehicle": { "page_title": "Editar Veículo", "success": "Veículo editado com sucesso" },
    "new_vehicle": {
      "form_fields": { "without_tracker": "Não possui rastreador" },
      "page_title": "Cadastrar Veículo",
      "success": "Veículo adicionado com sucesso"
    },
    "vehicles_list": {
      "add_new_vehicle": "Adicionar veículo",
      "change_vehicle": "Alterar veículo",
      "page_title": "Veículos",
      "table": { "tracking": "Rastreador" },
      "vehicle_deleted": "Veículo excluído com sucesso!"
    }
  },
  "vessels": { "country": "País da Embarcação" },
  "warnings": {
    "after_deleting_temporary": "Após ser excluído você poderá recuperá-lo ao clicar em descartar alterações antes de salvar. Deseja prosseguir?",
    "after_deleting_this_information": "Após ser excluída essa informação não poderá ser recuperada. Deseja prosseguir?",
    "are_you_sure": "Você tem certeza?",
    "empty_general_list_message": "Ainda não há informações aqui.",
    "not_informed": "-",
    "process_empty_data_list_message": "Este processo ainda não tem dados cadastrados.",
    "there_is_already_a_record_registered_with_this_number": "Já existe um registro cadastrado com esse número.",
    "this_action_can_not_be_undone": "Essa ação não poderá ser desfeita. Deseja prosseguir?",
    "this_item_can_not_be_deleted": "Não é possível deletar este item!",
    "this_will_be_automatically_fulfilled": "Este campo será preenchido automaticamente quando o pedido for criado.",
    "to_delete_item": "Excluir {{text}} ?",
    "without_data_to_export": "Não há dados para serem exportados"
  },
  "yup": {
    "at_least_one": "Esse campo deve ter no mínimo 1 elemento.",
    "cannot_be_equal_to": "Esse campo deve ser diferente do campo {{otherField}}",
    "mixed_invalid_field": "Campo inválido.",
    "mixed_required_field": "Esse campo é obrigatório",
    "number_max": "Esse campo deve ser menor que {{max}}.",
    "number_min": "Esse campo deve ser maior que {{min}}.",
    "required_field": "O campo {{ fieldName }} é obrigatório.",
    "string_email": "Esse campo deve ser um email válido.",
    "string_https_url": "A URL deve utilizar o protocolo HTTPS.",
    "string_max": "Esse campo deve ser menor que ${max} caracteres.",
    "string_min": "Esse campo deve ser maior que ${min} caracteres."
  }
}
